import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 96%;  
    font-size: 0.8rem;
    padding: 0.25rem 0;
    height: 75px;
    border-radius: 40px;
    box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(20, 20, 20, 0.07) !important;
    @media (max-width: ${({ theme }) => theme.size.laptopL}) {
     height: 90px;
    }
     @media (max-width: ${({ theme }) => theme.size.mobileL}) {
      width: 100%; 
       border-radius: 25px;
    
    }
    
`;

export const HeaderLinks = styled.div`
    height: 100%;
    width: 22%;
    display: flex;
    align-items: center;
  justify-content: end;
    margin-right: 0.1rem;
      @media (max-width: ${({ theme }) => theme.size.laptopL}) {
      flex-direction:column;
        justify-content: space-between;
      align-items: end;
      }
      @media (max-width: ${({ theme }) => theme.size.mobileL}) {
      width: 35%; 
    }
`;

export const TitleDiv = styled.div`
   display: flex;
    justify-content: center;
    /*margin-right:35%;*/
   width: ${({ theme, isLocataire }) => isLocataire ? "100%" : "78%"};

   color: #344767;
   letter-spacing:0.05rem;
   font-weight:700;
   font-size:1.875rem;
   line-height:1.375;
      & img {
           width: "275px"
           }


       @media (max-width: ${({ theme }) => theme.size.tabletL}) {
         font-size:0.875rem;
             margin-left: 8px;
             flex-direction: column;
             align-items: center;
                & img {
                   width:180px;
               }
    }

    @media (max-width: ${({ theme }) => theme.size.mobileL}) {
      width:65%; 
       width: ${({ theme, isLocataire }) => isLocataire ? "100%" : "65%"};
    }      
    
`;

export const Hlink = styled(Link)`
  /* width:67%;*/
    color: #344767;
    padding: 0.5rem 1rem;
    padding-right: 1rem;
    padding-left: 1rem;
    font-weight: 400;
    font-size: 0.875rem;
    text-decoration: none;
    cursor: pointer;
    letter-spacing: -0.025rem;
    font-family: sans-serif;
        margin-right: 40PX;
    @media (max-width: ${({ theme }) => theme.size.laptopL}) {
        font-size: 0.725rem;
          width:100%;
          text-align: end;
           margin-right: 1PX;
        }

      @media (max-width: ${({ theme }) => theme.size.mobileL}) {
        padding-right: 0.1rem;
        padding-left: 0.1rem;
    } 
`;

export const HLang = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
`;

export const HTheme = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    color: ${({theme, isActive}) => isActive ? theme.colors.primary : theme.colors.secondary};
    cursor: pointer;

    & span {
        color: ${({lcolor}) => lcolor || '#063E53'} ;
        margin-left: 0.25rem;
    }
`;

export const EICol = styled.div`
 width: 365px;
    display: none;
    position: absolute;
    top: calc(100%);
    right: 3%;
    z-index: 9000;
    height: fit-content;
    background-color: #fefefe;
    border-radius: 8px;
    box-shadow: 2px 1px 5px 1px #7b7b7b;
    border-radius: 6px;
    padding-top: 10px;

    &:before {
      content: "";
    position: absolute;
    top: -26px; /* Ajustez selon vos besoins */
    right: 0px; /* Ajustez selon vos besoins */
    border-width: 15px;
    border-style: solid;
    border-color: transparent transparent #fefefe transparent;
    }
`

export const IconDiv = styled.div`
 position: relative;
       margin-left: -50px;
    padding-left: 10px;
        margin-right: 16px;
&:hover ${EICol} {
        display: block;
    }
`

export const HliItem = styled.li` 
text-decoration: underline;
cursor: pointer;
margin-bottom: 0.5rem;
font-style: italic;
    letter-spacing: -0.025rem;
    font-size: 1rem;

&:hover {
    color: #cb0c9f;
}
`

export const HulContainer = styled.ul` 
list-style-type: none;
padding: 0px 0px 0px 12px;
color: #67748e;
`

export const TitleHeader = styled.h3` 
font-weight: 700;
letter-spacing: -0.05rem;
font-size: 1.875rem;
line-height: 1.375;
color: #344767;
   @media (max-width: ${({ theme }) => theme.size.tabletL}) {
       font-size: 1.575rem;
   }
    @media (max-width: ${({ theme }) => theme.size.mobileL}) {
      font-size: 1.275rem;
    }

`

export const BtnDeconnexion = styled.button`

      background-color: #e9ecef;
    border: 1px solid #cb0c9f;
    letter-spacing: -0.025rem;
    text-transform: uppercase;
    border-radius: 0.5rem;
    color: #344767;
    padding: 0.45rem 1rem;
  @media (max-width: ${({ theme }) => theme.size.tabletL}) {
       padding: 0.245rem 0.7rem;
   }
`;
